import { render, staticRenderFns } from "./AudioPlay.vue?vue&type=template&id=685e2ff5&scoped=true&"
import script from "./AudioPlay.vue?vue&type=script&lang=js&"
export * from "./AudioPlay.vue?vue&type=script&lang=js&"
import style0 from "./AudioPlay.vue?vue&type=style&index=0&id=685e2ff5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685e2ff5",
  null
  
)

export default component.exports